import { makeStyles } from '@material-ui/core';

export const usePageStyle = makeStyles(theme => ({
  wrapper: {
    backgroundColor: 'white',
    height         : 'auto',
    minHeight      : '100vh',
    position       : 'relative',
    top            : '0',
  },
  fullPage: {
    padding                       : '120px 0',
    position                      : 'relative',
    minHeight                     : '100vh',
    display                       : 'flex!important',
    margin                        : '0',
    border                        : '0',
    color                         : '#fff',
    alignItems                    : 'center',
    backgroundSize                : 'cover',
    backgroundPosition            : 'center center',
    height                        : '100%',
    [theme.breakpoints.down('sm')]: {
      minHeight: 'fit-content!important',
    },
  },
}));
